import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tabTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: '16px',
    fontWeight: 700,
    color: '#2C2D3E',
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 700,
    color: '#2C2D3E',
    padding: '5px 0px',
  },
  switchTitle:{
    lineHeight: '30px'
  },
  switchGrid:{
    display: 'inline-flex'
  },
  item: {
    display: 'flex',
    alignSelf: 'center',
    width: '100%',
    justifyContent: 'space-between',
    padding: '10px 25px 0px 15px',
    '& .MuiFormHelperText-contained': {
      margin: '0',
    },
  },
  headerRow: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0px',
  },
  helperRow: {
    height: '15px',
    fontSize: '12px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between',
  },
  listHeader: {
    height: '50px',
    display: 'flex',
    width: 'calc(100% - 10px)',
    justifyContent: 'space-between',
  },
}));
